import React from "react";
import CookieConsent from "react-cookie-consent";

function CookieConsentBanner() {
    return (
        <CookieConsent
            location="top"
            buttonText="Accept"
            cookieName="cookieConsent"
            style={{background: "#202831"}}
            buttonStyle={{padding: "8px 32px", borderRadius: "4px", color: "#FFF", background: "#51A6C6"}}
            buttonClasses="cookie-consent-btn"
            expires={150}
            overlay={true}
        >
            We use cookies to improve user experience and analyse website traffic.<br/>
            <span style={{fontSize: "16px"}}> By clicking “Accept“, you agree to our website's cookie use as described in our&nbsp;<a target="_blank" rel="noopener noreferrer" href="https://docs.premierit.com/policies/web/privacy-notice.html">Privacy</a>
                &nbsp;notice.</span>
        </CookieConsent>
    );
}
export default CookieConsentBanner;
